<template>
  <span>
    <v-icon
      small
      title="Transferências do Produto"
      @click="dialog_transferencia = true"
    >
      mdi-information-outline
    </v-icon>

    <SysDialogFullScreen
      v-model="dialog_transferencia"
      titulo="Detalhamento das Transferências"
      :search="pesquisar"
    >
      <template #titulo-parte-direita>
        <div class="font-18">
          <span class="font-weight-medium">Total:</span>
          &nbsp;{{ TOTAL_TRANSFERENCIAS }}
        </div>
      </template>

      <div class="d-flex align-center py-2 mx-2">
        <span class="font-18 font-weight-medium text-black">
          {{ `Produto: ${produto.idproduto} - ${Helpers.primeiraLetraMaiuscula(produto.descricao_produto)}` }}
        </span>

        <v-spacer></v-spacer>

        <div class="w-450">
          <v-text-field
            class="mr-4"
            v-model="pesquisar"
            dense
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
            clearable
          />
        </div>
      </div>

      <SysDataTable
        :headers="headers"
        :items="desserts"
        :height="alturaDaJanela - 148"
        :item-height="45"
        :search="pesquisar"
        class-scroll="mx-2"
        class="text-black"
      >
        <template #item.filial_origem="{ item }">
          {{  item.filial_origem }}

          <template v-if="item.nome_fantasia_origem">
            - {{ item.nome_fantasia_origem }}
          </template>
        </template>

        <template #item.filial_destino="{ item }">
          {{  item.filial_destino }}

          <template v-if="item.nome_fantasia_destino">
            - {{ item.nome_fantasia_destino }}
          </template>
        </template>

        <template #item.qtde_item="{ value }">
          {{  Helpers.formatarValor(value) }}
        </template>
      </SysDataTable>
    </SysDialogFullScreen>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import Responsividade from "@/helpers/ResponsiveHeight";
import SysDialogFullScreen from '@/components/padraoDeLayout/SysDialogFullScreen.vue';
import SysDataTable from '@/components/utils/dataTable/sysDataTable/Index.vue';
import { buscarDadosTransferenciaProduto } from "./TransferenciaApi";

export default {
  name: "Transferencia",
  components: { SysDialogFullScreen, SysDataTable },
  mixins: [Responsividade],
  props: {
    produto: Object,
  },
  data() {
    return {
      pesquisar: '',
      dialog_transferencia: false,
      headers: [
        { text: 'Filial origem',      value: 'filial_origem' },
        { text: 'Filial destino',     value: 'filial_destino' },
        { text: 'Pedido',             value: 'pedido' },
        { text: 'Data emissão',       value: 'emissao' },
        { text: 'Item',               value: 'item' },
        { text: 'Quantidade',         value: 'qtde_item' },
      ],
      desserts: []
    }
  },
  computed: {
    TOTAL_TRANSFERENCIAS() {
      return this.desserts.reduce((a, b) => a + Number(b.qtde_item), 0)
    }
  },
  watch: {
    dialog_transferencia(valor) {
      if (valor) this.buscarDadosTransferenciaProduto();
    }
  },
  methods: {
    buscarDadosTransferenciaProduto() {
      this.desserts = [];

      const parametros = {
        id_grupo: this.produto.idgrupo,
        filial: this.produto.filial,
        idproduto: this.produto.idproduto
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        buscarDadosTransferenciaProduto(parametros)
          .then((dados) => this.desserts = dados)
          .catch(() => this.Helpers.logout())
      );
    }
  }
}
</script>

<style>

</style>
